module.exports = __webpack_public_path__ + "cf480f9074bee321144f24846e16ea93.svg";